import { render, staticRenderFns } from "./ReceivedOrderOriginWarehouse.vue?vue&type=template&id=4a8c5d53&"
import script from "./ReceivedOrderOriginWarehouse.vue?vue&type=script&lang=js&"
export * from "./ReceivedOrderOriginWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedOrderOriginWarehouse.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports